/**
 * Adds a class to an element. Has polyfill for IE9.
 *
 * @param Element element Element to which the class has to be added.
 * @param String newClass New class to be added to element.
 */
function addClass(element, newClass) {
  if (element.classList) {
    element.classList.add(newClass);
  } else {
    // IE polyfill
    const arr = element.className.split(" ");
    if (arr.indexOf(newClass) === -1) {
        element.className += " " + newClass;
    }
  }
}

export { addClass };